const typedEntries = <T extends Record<string, string>>(obj: T): [keyof T, T[keyof T]][] => {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
};

const tagToPrettyObj = {
  '{{contact.name}}': "Contact's Name",
  '{{contact.first_name}}': "Contact's First Name",
  '{{contact.last_name}}': "Contact's Last Name",
  '{{contact.email}}': "Contact's Email",
  '{{contact.phone_number}}': "Contact's Phone Number",
  '{{contact.source}}': "Contact's Source",
  '{{team.company}}': "Team's Company Name",
  '{{scheduling_link.phone_screen}}': 'Phone Screen Scheduling Link',
  '{{scheduling_link.interview}}': 'Interview Scheduling Link',
  '{{scheduling_link.pipeline_review}}': 'Pipeline Review Scheduling Link',
} as const;

export type MergeTag = keyof typeof tagToPrettyObj;
export type MergePretty = (typeof tagToPrettyObj)[MergeTag];

export const tagToPrettyMap = new Map<string, string>(typedEntries(tagToPrettyObj));
export const prettyToTagMap = new Map<string, string>(typedEntries(tagToPrettyObj).map(([k, v]) => [v, k]));

export const mergeTagList: readonly MergeTag[] = Object.keys(tagToPrettyObj) as MergeTag[];
export const mergePrettyList: readonly MergePretty[] = Object.values(tagToPrettyObj);
